// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', sans-serif;
  background: #f8fafc;
  color: #1e293b;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Work Sans', sans-serif;
}

.App {
  min-height: 100vh;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Smooth transitions */
button, a, input, textarea {
  transition: background-color 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s;
}

/* File drop zone styles */
.drop-zone {
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s;
  background: #f8fafc;
}

.drop-zone.drag-over {
  border-color: #3b82f6;
  background: #eff6ff;
}

.drop-zone:hover {
  border-color: #94a3b8;
}

/* Status badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
}

.status-badge.recu {
  background: #dbeafe;
  color: #1e40af;
}

.status-badge.traitement {
  background: #fef3c7;
  color: #92400e;
}

.status-badge.traite {
  background: #d1fae5;
  color: #065f46;
}

.status-badge.archive {
  background: #e5e7eb;
  color: #374151;
}

/* Animation utilities */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.3s ease-out;
}

/* Card hover effect */
.card-hover {
  transition: transform 0.2s, box-shadow 0.2s;
}

.card-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,iFAAiF;AACnF;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  background: #f8fafc;\n  color: #1e293b;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Work Sans', sans-serif;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Smooth transitions */\nbutton, a, input, textarea {\n  transition: background-color 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n/* File drop zone styles */\n.drop-zone {\n  border: 2px dashed #cbd5e1;\n  border-radius: 8px;\n  padding: 2rem;\n  text-align: center;\n  transition: all 0.3s;\n  background: #f8fafc;\n}\n\n.drop-zone.drag-over {\n  border-color: #3b82f6;\n  background: #eff6ff;\n}\n\n.drop-zone:hover {\n  border-color: #94a3b8;\n}\n\n/* Status badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.status-badge.recu {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.status-badge.traitement {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-badge.traite {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge.archive {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n/* Animation utilities */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in {\n  animation: fadeIn 0.3s ease-out;\n}\n\n/* Card hover effect */\n.card-hover {\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.card-hover:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
